export default {
      id: "reefer__fuel-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/icons.svg#reefer__fuel",
      toString: function () {
        return this.url;
      }
    }